import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function BottomTabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  
  const tabs = [
    { id: 'home', label: t('home'), icon: 'ri-home-5-line', iconFilled: 'ri-home-5-fill', path: '/home' },
    { id: 'jobs', label: t('jobs'), icon: 'ri-file-list-3-line', iconFilled: 'ri-file-list-3-fill', path: '/jobs' },
    { id: 'earnings', label: t('earnings'), icon: 'ri-money-dollar-circle-line', iconFilled: 'ri-money-dollar-circle-fill', path: '/earnings' },
    { id: 'schedule', label: t('schedule'), icon: 'ri-calendar-line', iconFilled: 'ri-calendar-fill', path: '/schedule' },
    { id: 'profile', label: t('profile'), icon: 'ri-user-line', iconFilled: 'ri-user-fill', path: '/profile' },
  ];
  
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="grid grid-cols-5 h-16">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center gap-0.5 transition-colors ${
                isActive ? 'text-[#E31837]' : 'text-gray-500'
              }`}
            >
              <i className={`${tab.icon} text-xl`}></i>
              <span className="text-[0.625rem] font-medium">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
